import api from '@/libs/api'
import store from '@/store'

const getProjectId = () => store.state.app.projectId
const getNamespace = () => store.state.app.namespace

export default {
  namespaced: true,
  state: {
    ingressSetResultInfo: {},
    ingresses: [],
    ingress: {},
    fetchingIngresses: false,
    addingIngress: false,
    removingIngress: false,
  },
  mutations: {
    SET_INGRESSES(state, data) {
      state.ingresses = data.result
    },
    SET_INGRESS(state, data) {
      state.ingress = data.result
    },
    SET_FETCHING_INGRESSES(state, value) {
      state.fetchingIngresses = value
    },
    SET_ADDING_INGRESS(state, value) {
      state.addingIngress = value
    },
    SET_REMOVING_INGRESS(state, value) {
      state.deletingIngress = value
    },
  },
  actions: {
    fetchIngresses({ commit }) {
      commit('SET_FETCHING_INGRESSES', true)
      return new Promise((resolve, reject) => {
        api('kyubi').get(`projects/${getProjectId()}/namespaces/${getNamespace()}/ingress`)
          .then(response => {
            commit('SET_INGRESSES', response.data)
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
          .finally(() => { commit('SET_FETCHING_INGRESSES', false) })
      })
    },
    getIngress({ commit }, ingress) {
      commit('SET_FETCHING_INGRESSES', true)
      return new Promise((resolve, reject) => {
        api('kyubi').get(`projects/${getProjectId()}/namespaces/${getNamespace()}/ingress/${ingress}`)
          .then(response => {
            commit('SET_INGRESS', response.data)
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
          .finally(() => { commit('SET_FETCHING_INGRESSES', false) })
      })
    },
    addIngress({ commit }, ingress) {
      commit('SET_ADDING_INGRESS', true)
      return new Promise((resolve, reject) => {
        api('kyubi').post(`projects/${getProjectId()}/namespaces/${getNamespace()}/ingress`, ingress)
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
          .finally(() => { commit('SET_ADDING_INGRESS', false) })
      })
    },
    removeIngress({ commit }, ingress) {
      commit('SET_REMOVING_INGRESS', true)
      return new Promise((resolve, reject) => {
        api('kyubi').delete(`projects/${getProjectId()}/namespaces/${getNamespace()}/ingress/${ingress}`)
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
          .finally(() => { commit('SET_REMOVING_INGRESS', false) })
      })
    },
  },
}
